var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="alert alert-danger" role="alert">\n  <strong style="text-transform: none;">'+
((__t=( title ))==null?'':_.escape(__t))+
'</strong> '+
((__t=( subtitle ))==null?'':_.escape(__t))+
'\n</div>\n';
}
return __p;
};
